"use strict";

(function () {

	angular.module('app.services')
		.factory("authentication", AuthenticationService);

    AuthenticationService.$inject = ['$http', '$q', '$cookies', 'authenticationSettings', '$rootScope','$browser','$document'];
    function AuthenticationService($http, $q, $cookies, authenticationSettings, $rootScope,$browser,$document) {

		var serviceBase = authenticationSettings.apiServiceBaseUri;
		if (serviceBase.indexOf('/', serviceBase.length - 1) === -1) {
			serviceBase = serviceBase + '/';
		}

		var cookieDomain = authenticationSettings.cookieDomain;

		var authentication = {
			isAuth: false,
			username: "",
			redirectUrl: ""
		};

		var vm = this;

		fillAuthData();

		return {
			canUserFinishRegistration: canUserFinishRegistration,
			login: login,
			logout: logout,
			redCapLogin: redCapLogin,
			register: register,
			getSecurityQuestion: getSecurityQuestion,
			forgotPassword: forgotPassword,
			passwordChange: passwordChange,
			resetPassword: resetPassword,
			getAuthData: getAuthData,
			fillAuthData: fillAuthData,
            authentication: authentication,
            getNonce: getNonce,
            isUserExistInAzure: isUserExistInAzure,
            setAuthDataCookie: setAuthDataCookie,
            isUserRegisteredForMFA: isUserRegisteredForMFA
		};

		function canUserFinishRegistration(username, registrationToken) {
			var encodedToken = encodeURIComponent(registrationToken);
			return $http.get(serviceBase + 'auth/register/is-allowed?username=' + username + '&registrationtoken=' + encodedToken).then(function (response) {
				return response.data;
			});
		}

		//
		// Login - request { username: string, password: string, applicationCacheKey: string, rememberUsername: boolean }
		//
		function login(request) {
			var data = {
				Username: request.username,
				Password: request.password,
				ApplicationCacheKey: request.applicationCacheKey
			};

			var deferred = $q.defer();
            $http.post(serviceBase + "auth/login?isDefaultProvider=" + request.isDefaultProvider, data).then(function (response) {
                localStorage.setItem('cookiedata', JSON.stringify(response.data));                
				authentication.isAuth = true;
				authentication.username = request.username;

                deferred.resolve(response);
            }, function (err) {
                deferred.reject([err]);
            });

			return deferred.promise;
        }
        //
        //Nonce Token
        //
        function getNonce(username) {
            var nonceData = {
                UserNonce: "",
                Codechallenge: "",
                Codeverfier: ""
            };

            var deferred = $q.defer();
            $http.get(serviceBase + "auth/azure/user-nonce?signInName=" + username).then(function (response) {
                if (response) {

                    nonceData = response;
                    deferred.resolve(nonceData);
                }
            }, function (err) {
                deferred.reject([err]);
            });

            return deferred.promise;

        }


        function isUserExistInAzure(userName) {
            var deferred = $q.defer();
            $http.get(serviceBase + "auth/azure/create-user?signInName=" + userName).then(function (response) {
                if (response) {
                    
                    deferred.resolve(response);
                }
            }, function (err) {
                deferred.reject([err]);
            });

            return deferred.promise;

        }

        function isUserRegisteredForMFA(userName) {
            var deferred = $q.defer();
            $http.get(serviceBase + "auth/azure/isregistered-mfaoptions?signInName=" + userName).then(function (response) {
                if (response) {

                    deferred.resolve(response.data);
                }
            }, function (err) {
                deferred.reject([err]);
            });

            return deferred.promise;

        }

		//
		// Logout
		//
        function logout() {           
			var authData = getAuthData();
			if (authData) {

				var userCacheKey = authData.user_cache_key;

				// clear auth data
				authData = {};

				// clear the cookie
				setAuthDataCookie(authData);

				// delete cookie - this isn't removed immediately
				deleteAuthDataCookie();

				authentication.isAuth = false;
                authentication.userName = "";            

				// logout
				if (userCacheKey) {
					$http.delete(serviceBase + "auth/logout?userCacheKey=" + userCacheKey);
                }         
			}
		}

		/**
		 * Password Change
		 * API endpoint for customers who need to change password on initial login
		 * @param {*} request
		 */
        function passwordChange(request) {
            var data = {
                Username: request.username,
                Password: request.password
            };
            var deferred = $q.defer();
            
            // This feels like a giant, embarrassing Band-Aid, but SSO has never had auth headers set up before
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + request.token;

           return $http.post(serviceBase + 'auth/password/change', data).then(function (response) {
              
               return response;

            }, function (err) {
                deferred.reject([err]);
            });

        }

		/**
		 * redCapLogin
		 * Allow users to login through RedCap - params: login, fingerprint, version
		 * @param {*} login
		 * @param {*} fingerprint
		 * @param {*} local
		 * @param {*} version
		 */
		function redCapLogin(login, fingerprint, local, version) {
			var deferred = $q.defer();

			$http.post(serviceBase + 'auth/hash-client?valueToHash='+login+'&fingerprint='+fingerprint+'&isLocal='+local+'&version='+version)
				.then(function (response) {
					var hash =  'redcap' + response.data;
					deferred.resolve(hash);
				}, function(err) {
					deferred.reject();
				});

			return deferred.promise;
		}

		//
		// Register - request { username: string, token: string, password: string, confirmPassword: string, question: string, answer: string, confirmAnswer: string }
		//
		function register(request) {
			var data = {
				Username: request.username,
				Token: request.token,
				Password: request.password,
				ConfirmPassword: request.confirmPassword,
				Question: request.question,
				Answer: request.answer,
				ConfirmAnswer: request.confirmAnswer
			};

			return $http.post(serviceBase + "auth/register", data).then(function (response) {
				return response.data;
			});
		}

		//
		// Get Security Question - request { username: string }
		//
		function getSecurityQuestion(request) {
			return $http.get(serviceBase + "auth/password/question?username=" + request.username).then(function (response) {
				return response.data;
			});
		}

		//
		// Forgot Password - request { username: string, answer: string }
		//
		function forgotPassword(request) {
			var data = {
				Username: request.username,
				Answer: request.answer,
				RedirectUrl: $rootScope.redirectURL
			};

			return $http.post(serviceBase + 'auth/password/forgot', data).then(function (response) {
				return response.data;
			});
		}

        //
        // Reset Password - request { username: string, password: string, token: string }
        //
        function resetPassword(request) {
            var data = {
                Username: request.username,
                Token: request.token,
                Password: request.password
            };
            var deferred = $q.defer();
            
           return $http.post(serviceBase + "auth/password/reset", data).then(function (response) {
               
               return response

            }, function (err) {
                   
                    deferred.reject([err]);
                });
            
        }
        //
        // Fill Authorization Data
        //
        function fillAuthData() {
            //populates data from cookie
            var authData = getAuthData();
            if (authData) {
                if (!authData.access_token) {
                    // not logged in
                    authentication.savedUsername = authData.savedUsername;
                } else {
                    // logged in
                    authentication.isAuth = true;
                    authentication.username = authData.username;

					// This feels like a giant, embarrassing Band-Aid, but SSO has never had auth headers set up before
					$http.defaults.headers.common['Authorization'] = 'Bearer ' + authData.access_token;
				}
			}

			authentication.redirectUrl = $rootScope.redirectURL;
		}

		//
		// Get Authorization Data
		//
		function getAuthData() {
			var authData = $cookies.getObject(authenticationSettings.cookieName);
			if (!authData) {
				return null;
			}

			return authData;
		}

		function setAuthDataCookie(authData, isRedcap= false) {
			// This will ensure that ONLY the needed values will make it to the authData cookie and the permissions will be stripped from the object.
			delete authData.product_permissions;
			delete authData.application_permissions;
			if (authData.organization_units && authData.organization_units[0]) {
				authData.organization_units = [authData.organization_units[0]];
			}
			authData.Env = getEnvFromDomain();
			if(isRedcap)
			{
			  $document[0].cookie = buildCookieString(authenticationSettings.cookieName,angular.toJson(authData),{ domain: cookieDomain, samesite: "None", secure:true});
				//$cookies.putObject(authenticationSettings.cookieName, authData, { domain: cookieDomain, samesite: "None"});
			}
			else
			{
			    $cookies.putObject(authenticationSettings.cookieName, authData, { domain: cookieDomain });

			}
		}
		function buildCookieString(name, value, options) {
			var path, expires;
			options = options || {};
			expires = options.expires;
			var cookiePath = $browser.baseHref();
			path = angular.isDefined(options.path) ? options.path : cookiePath;
			if (angular.isUndefined(value)) {
			  expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
			  value = '';
			}
			if (angular.isString(expires)) {
			  expires = new Date(expires);
			}
		
			var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
			str += path ? ';path=' + path : '';
			str += options.domain ? ';domain=' + options.domain : '';
			str += expires ? ';expires=' + expires.toUTCString() : '';
			str += options.secure ? ';secure' : '';
			str += options.samesite ? ';samesite=' + options.samesite : '';
		
			// per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
			// - 300 cookies
			// - 20 cookies per unique domain
			// - 4096 bytes per cookie
			var cookieLength = str.length + 1;
			if (cookieLength > 4096) {
			  $log.warn('Cookie \'' + name +
				'\' possibly not set or overflowed because it was too large (' +
				cookieLength + ' > 4096 bytes)!');
			}
		
			return str;
		  }
		
		function deleteAuthDataCookie() {
			$cookies.remove(authenticationSettings.cookieName);
		}

		function getEnvFromDomain() {
			switch (cookieDomain) {
                case '.dv.autopoint.com':
                    return 'dev';
                case '.qa.autopoint.com':
                    return 'qa';
                case '.st.autopoint.com':
                    return 'stage';
                case '.autopoint.com':
                    return 'prod';
                default:
                    return 'local';
            }
		}
	}
})();
